import { inject, Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { $app } from "@app/app.service";

import { DataService } from '@data/service/data.service';
import { ConfigService } from '@app/shared/services/config.service';


@Injectable()
export class AppBasicService {

    console: boolean = $app.core.modeDevel;
    logPrefix: string = '@service - ' + this.constructor.name;
    configSevice = inject(ConfigService);
    public apiUrl: string = this.configSevice.apiUrl;

    public httpOptions: any = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache'
        })
        //,withCredentials:true
        //,'Cache-control': 'no-cache'
    };

    public http: HttpClient;
    public dataSrv: DataService;

    constructor(public httpRef: HttpClient,
        public dataSrvRef: DataService) {

        this.http = httpRef;
        this.dataSrv = dataSrvRef;
    }
}

